const data = {
  id: "insurance_burdens",
  title: "Insurance Burdens",
  intro: "Your zip code, your credit score, and which side of town you live on can change your premium by hundreds of dollars — for the exact same coverage. Predatory pricing, denied claims, coverage deserts, and the industry's grip on state policy — documented.",
  tabs: [
    {
      id: "health",
      label: "Health Insurance",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "auto",
      label: "Auto Insurance",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "dental_vision",
      label: "Dental & Vision",
      stats: [],
      issues: [],
      trail: []
    },
    {
      id: "homeowners",
      label: "Homeowners",
      stats: [],
      issues: [],
      trail: []
    }
  ]
};
export default data;
